import {ADD_RECORD} from '../actions/popupdata/index'

const initialState = {
    records: []
  };

  function recordReducer(state = initialState, action) {
    switch (action.type) {
      case ADD_RECORD:
        return {
          ...state,
          records: [...state.records, action.payload]
        };
      default:
        return state;
    }
  } 
  
  export default recordReducer;
